import { useEffect, useState } from 'react';
import { useParams } from 'wouter';

import { fetchPublicSimulation } from '@/lib/publicShare';
import { useSimulatorState } from '@/store/useSimulatorState';

import { ChartsArea } from '@/components/charts/ChartsArea';
import { ConfigSummary } from '@/components/ConfigSummary';
import { Badge } from '@/components/ui/badge';
import { KpiCardsRow } from '@/components/kpi/KpiCardsRow';
import { ScenarioHeading } from '@/components/ScenarioHeading';

export function PublicSimulationPage() {
  const { slug } = useParams<{ slug: string }>();
  const [status, setStatus] = useState<'loading' | 'ready' | 'error'>('loading');

  useEffect(() => {
    if (!slug) return;
    (async () => {
      try {
        const record = await fetchPublicSimulation(slug);
        useSimulatorState.setState({ ...record.state, simulationId: null });
        setStatus('ready');
      } catch {
        setStatus('error');
      }
    })();
  }, [slug]);

  if (status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">
        Chargement…
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">
        Ce lien de partage est invalide ou a été désactivé.
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="border-b bg-card">
        <div className="mx-auto flex max-w-[1600px] items-center justify-between gap-4 p-4">
          <div className="flex items-center gap-2.5">
            <div className="flex size-7 items-center justify-center rounded-lg bg-primary text-sm font-bold text-primary-foreground">
              S
            </div>
            <h1 className="text-sm font-semibold">SaaS Pricing Simulator</h1>
          </div>
          <Badge className="rounded-full bg-accent px-3.5 py-1 text-accent-foreground">
            Lecture seule
          </Badge>
        </div>
      </header>
      <main className="mx-auto flex max-w-[1600px] flex-col gap-6 p-4 sm:p-6">
        <ScenarioHeading />
        <KpiCardsRow />
        <ConfigSummary />
        <ChartsArea />
      </main>
    </div>
  );
}
